import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 100%;

  .slider {
    width: 100%;
  }

  .slick-list {
    margin-bottom: 10px;
  }

  .slick-dots li {
    width: 5vw;
  }

  .slick-dots li button {
    width: 5vw;
  }

  .slick-dots li button:before {
    font-size: 12vw;
    color: #cdcdcd;
  }

  .slick-dots li.slick-active button:before{
    color: #cdcdcd;
  }
`
